export default __webpack_public_path__ + "static/media/coolSky.ee294ba6.webp";